import React from 'react';
import Feed from '../components/Feed/Feed';
import Head from '../components/Header/Head';
import Header from '../components/Header/Header';
import withApollo from '../lib/withApollo';

const DiscoverFeed = () => {
  return (
    <>
      <Head title="Random Travel Blogs" feedUrl="discover" />
      <Header active="discover" subheader="Discover" />
      <Feed active="discover" minScore={9000} orderby="random" />
    </>
  );
};

export default withApollo(DiscoverFeed);
